import { STATUS_TONE } from '@/nucleo/statusBadgeTokens';
import { cn } from '@/nucleo/utilitarios';
import { Badge } from '@/ui/base/badge';

import { APRESENTACAO_DO_STATUS } from './apresentacao';
import type { StatusSolicitacaoSme } from './tipos';

/**
 * O selo usa `Badge` + tom, e não `StatusBadge`: `humanizeLabel` transformaria
 * "Em triagem (SME)" em "Em triagem (Sme)".
 */
export function SeloDeSituacao({ status }: { status: StatusSolicitacaoSme }) {
  const { rotulo, tom } = APRESENTACAO_DO_STATUS[status];
  return (
    <Badge variant="outline" className={cn('font-medium', STATUS_TONE[tom])}>
      {rotulo}
    </Badge>
  );
}
